import { render, staticRenderFns } from "./BasicSetupBankDetail.vue?vue&type=template&id=325101e7&"
import script from "./BasicSetupBankDetail.vue?vue&type=script&lang=js&"
export * from "./BasicSetupBankDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports